import { WorkflowLayoutTriggerDetailModel } from "src/store/models/ui/workflowLayoutTrigger/workflowLayoutTriggerDetail";
import { WorkflowLayoutTriggerUIModel } from "src/store/models/ui/workflowLayoutTrigger/workflowLayoutTriggerTable";

export const encooWorkflowLayoutTriggerUIModels = {
  workflowLayoutTriggerDetail: WorkflowLayoutTriggerDetailModel,
  workflowLayoutTriggerTable: WorkflowLayoutTriggerUIModel,
};
